import NewMedicalDocument from "../../utils/medicalDocument/new";
import { prescriptionDocumentType } from "../../utils/medicalDocument/documentTypes";
import MedicineForm from "./form/medicine";
import DateForm from "./form/Date";

export const prescriptionModule = {
  ...prescriptionDocumentType,
  MedicineForm,
  DateForm,
};

const PrescriptionCreator = () => <NewMedicalDocument modules={[prescriptionModule]} />;

export default PrescriptionCreator;
